import React from "react";
import { basename } from "../../../config"

function Index() {
  return (
    <div className="noPageFound">
      <img src={`/${basename}/Assets/Images/mtslogo.svg`} alt="mtsLogo" />
      <p>You don't have access to this feature!</p>
    </div>
  );
}

export default Index;
